import axios from 'axios'
import { ElMessageBox, ElMessage, ElLoading } from 'element-plus'
import store from '@/store'
import { getAppUserToken, getAppBaseUrl, getRedirectUrl } from '@/utils/request'
import errorMap from './http-error-map.js'
import { isPlainObject } from 'lodash';
import Utils from '@/utils/utils.js'

//定义loading变量
let loading = null
let count = 0
//开始 加载loading
let startLoading = () => {
  loading = ElLoading.service({
    fullscreen: true,
    lock: true,
    text: '操作中，请稍候...',
    background: 'rgba(0, 0, 0, 0.7)'

  })
}
//结束 取消loading加载
let endLoading = () => {
  loading.close()
}
//showFullScreenLoading() 与 tryHideFullScreenLoading() 目的是合并同一页面多个请求触发loading
//声明一个变量
let needLoadingRequestCount = 0
let showFullScreenLoading = () => {
  //当等于0时证明第一次请求 这时开启loading
  if (needLoadingRequestCount === 0) {
    startLoading()
  }
  //全局变量值++
  needLoadingRequestCount++
}
let tryHideFullScreenLoading = () => {
  //小于等于0 证明没有开启loading 此时return
  if (needLoadingRequestCount <= 0) return
  //正常响应后 全局变量 --
  needLoadingRequestCount--
  //等于0 时证明全部加载完毕 此时结束loading 加载
  if (needLoadingRequestCount === 0) {
    endLoading()
  }
}


// create an axios instance
const service = axios.create({
  // url = base url + request url
  baseURL: process.env.VUE_APP_BASE_API,
  // withCredentials: true, // send cookies when cross-domain requests
  // request timeout
  timeout: 100000,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'Token': getToken()||''
  }
})
// request interceptor
service.interceptors.request.use(
  config => {
    config.baseURL = getAppBaseUrl(config, store.getters.appBaseURL, store.getters.appRootPath, store.getters.isAppPreview)
    if (!config.hideLoading) {
      showFullScreenLoading()
    }
    return config
  },
  error => {
    // do something with request error
    // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    tryHideFullScreenLoading()
    const res = response.data
    // if the custom code is not 20000, it is judged as an error.
    if (response.status !== 200) {
      ElMessage({
        message: res.message || 'Error',
        type: 'error',
      })

      // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
      if (response.status === 50008 || response.status === 50012 || response.status === 50014) {
        // to re-login
        ElMessageBox.confirm('You have been logged out, you can cancel to stay on this page, or log in again', 'Confirm logout', {
          confirmButtonText: 'Re-Login',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          store.dispatch('user/resetToken').then(() => {
            location.reload()
          })
        })
      }
      return Promise.reject(new Error(res.errMessage || 'Error'))
    } else {
      if (20001 === +res.errCode) {
        // count += 1
        return window.location.href = res.redirect_url
      }
      if (res.error || (res.hasOwnProperty('success') && !res.success)) {
        return Promise.reject(new Error(res.errMessage || 'Error'))
      }
      // 开发平台接口返回失败情况
      if (res.code===500) {
        return Promise.reject(new Error(res.msg || 'Error'))
      }
      if (res.respHeader&&res.respHeader.servRespCd =='11111111') { // 开发平台成功弹窗
        ElMessageBox.alert(res.respHeader.servRespDescInfo,{
          type:'success'
        })
        return Promise.reject(new Error(res.respHeader.servRespDescInfo))
      }
      if (res.respHeader&&res.respHeader.servRespCd!=='00000000') { // 开发平台接口失败弹窗
        ElMessageBox.alert(res.respHeader.servRespDescInfo,'出错了!',{
          type:'error'
        })
        return Promise.reject(new Error(res.respHeader.servRespDescInfo || 'Error'))
      }
      // if (res.sysRspHead&&res.sysRspHead.code!=='00000000') {
      //   return Promise.reject(new Error(res.sysRspHead.message || 'Error'))
      // }
      const resKeys = Object.keys(res);
      // 新连接器不再将外层的error、success等信息包装到data层，针对于应用内部这些信息需要通过代理暴露给页面
      if (resKeys.length === 4 && new Set([...resKeys, ...['errCode', 'data', 'errMessage', 'success']]).size === 4 && isPlainObject(res.data)) {
        const proxiedRes = new Proxy(res.data, {
          get(target, prop) {
            if (target[prop] === undefined) {
              return res[prop];
            }
            return target[prop];
          }
        });
        return proxiedRes;
      } 
      // 开发平台接口格式
      else if (new Set([...resKeys, ...['expandMap', 'respHeader', 'respBody']]).size === 3 && isPlainObject(res.respBody)) {
        return res.respBody
      }else {
        return res || {};
      }
    }
  },
  error => {
    tryHideFullScreenLoading()
    // 判断是否是超时错误
    const isTimeout = error.code === 'ECONNABORTED' || 
                     (error.message && error.message.includes('timeout'));
    
    if (isTimeout) {
      // 超时错误静默处理，不显示任何提示
      ElMessage({
        message:'网络异常，请稍后重试',
        type: 'error',
      })
      return Promise.reject({
        error: error,
        reason: '请求超时',
        success: false,
        data: '',
        isTimeout: true  // 标记为超时错误
      });
    }
    let response = error;
    if (response) {
      let errorKey = response.response?.status || response.code
    }
    return Promise.reject({
      error: error,
      reason: error.message,
      success: false,
      data: response != undefined ? response.data : ''
    })
  }
)
function resetConfig() {
  service.defaults.url = '';
  service.defaults.headers = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'Token': getToken()||''
  }
  service.defaults.timeout = 100000
}
/**
 * 封装request请求
 * @param url
 * @param method
 * @param data
 * @param headers
 * @param responseType
 * @param params
 * @param hideLoading  //是否隐藏loading动画
 * @param timeout      //设置timeout时间
 * @returns {Promise}
 */

function request({ url, method, data = {}, headers, responseType, params, hideLoading, rd = false, timeout }) {
  if (timeout) {
    service.defaults.timeout = timeout
  }
  // 设置自定义请求头
  ['Content-Type', 'Accept'].forEach(h => {
    headers && headers[h] && (service.defaults.headers[h] = headers[h])
  })
  let paramsData={
    reqBody:null,
    reqHeader:{
      reqSysSriNo: "1",
      globalBusiTrackNo: "1",
      servVerNo: "1",
      servNo: "1",
      servTpCd: "1",
      targetSysOrCmptNo: "1",
      txSendTime: "1",
      txStartTime: "1",
      dataCenterCode: "1",
      startChnlFgCd: "1",
      sendSysOrCmptNo: "1",
      startSysOrCmptNo: "1",
    },
  }
  paramsData=Object.assign(paramsData,{reqBody:data})
  return new Promise((resolve, reject) => {
    service.request({
      url,
      method,
      data:paramsData,
      // 默认与设置有个优先级
      headers: {
        ...{
          'redirectUrl': getRedirectUrl(),
          'x-user-token': getAppUserToken(),
          'x-mock': 0,
          'Token': getToken()||''
        },
      },
      responseType,
      params,
      hideLoading
    }).then(res => {
      rd ? resolve(res.data) : resolve(res)
    }).catch(err => {
      reject(err)
    })
    resetConfig();
  })
}
function loginRequest({ url, method, data = {}, headers, responseType, params, hideLoading, rd = false, timeout }) {
  if (timeout) {
    service.defaults.timeout = timeout
  }
  // 设置自定义请求头
  ['Content-Type', 'Accept'].forEach(h => {
    headers && headers[h] && (service.defaults.headers[h] = headers[h])
  })
  return new Promise((resolve, reject) => {
    service.request({
      url,
      method,
      data,
      // 默认与设置有个优先级
      headers: {
        ...{
          'redirectUrl': getRedirectUrl(),
          'x-user-token': getAppUserToken(),
          'x-mock': 0,
          'Token': getToken()||''
        },
      },
      responseType,
      params,
      hideLoading
    }).then(res => {
      rd ? resolve(res.data) : resolve(res)
    }).catch(err => {
      reject(err)
    })
    resetConfig();
  })
}
function getToken(){
  if(isCenter()){
    let token = Utils.getUrlParam().token||sessionStorage.getItem('TOKEN')
    return token
  }else{
    return Utils.getToken()
  }
}
function isCenter() {
  let urlType = Utils.getUrlParam().urlType||sessionStorage.getItem('URL_TYPE')
  if(urlType==='center'){
    return true
  }else {
    return false
  }
}
export {
  // ajax,
  // 发送请求
  request,
  loginRequest
  // sendAll // 批量发送请求
}
// export default service
